const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success: "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
          disabled: "El registro de usuarios está deshabilitado actualmente. Por favor, inténtelo más tarde.",
          redirecting: "Redirigiendo al pago...",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          confirmPassword: "Confirmar Contraseña",
          passwordRequirements: "Mínimo 8 caracteres, 1 mayúscula, 1 número y 1 carácter especial",
          company: "Nombre de la Empresa",
          phone: "WhatsApp (con código de país)",
          phoneHelper: "Ej: +54 9 11 9999-9999",
          document: "CPF o CNPJ",
          documentHelper: "Ingrese CPF (11 dígitos) o CNPJ (14 dígitos)",
          plan: "Plan",
          paymentMethod: "Método de pago",
          installments: "Cuotas",
          installmentsHelper: "Divide el total en hasta {{max}} cuotas en tu tarjeta de crédito.",
          installmentsOption: "{{count}}x de R$ {{value}}",
          installmentsOptionSingle: "Pago único — R$ {{value}}",
          planTotal: "Valor total del plan: R$ {{value}}",
        },
        paymentOptions: {
          pix: "PIX",
          boleto: "Boleto bancario",
          card: "Tarjeta de crédito",
        },
        consent: {
          label: "Acepto que mi plan se renovará automáticamente al final de cada período.",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        validation: {
          cpfValid: "¡CPF válido!",
          cpfInvalid: "¡CPF inválido! Verifica los dígitos.",
          cnpjValid: "¡CNPJ válido! Nombre de empresa completado automáticamente.",
          cnpjInvalid: "¡CNPJ inválido! Verifica los dígitos.",
          cnpjNotFound: "CNPJ no encontrado en la Receita Federal.",
          cnpjWarning: "CNPJ válido, pero no se pudo consultar la Receita Federal.",
          cnpjError: "Error al validar el documento. Intenta de nuevo.",
          phoneInvalid: "Número de WhatsApp inválido",
          phoneRequired: "WhatsApp es obligatorio",
          planRequired: "Seleccione un plan",
          paymentRequired: "Selecciona un método de pago",
          consentRequired: "Debes aceptar la renovación automática para continuar",
          installmentsRequired: "Selecciona el número de cuotas",
          passwordRequired: "La contraseña es obligatoria",
          passwordMin: "La contraseña debe tener al menos 8 caracteres",
          passwordMax: "La contraseña es demasiado larga",
          passwordUppercase: "La contraseña debe contener al menos 1 letra mayúscula",
          passwordNumber: "La contraseña debe contener al menos 1 número",
          passwordSpecialChar: "La contraseña debe contener al menos 1 carácter especial",
          passwordMatch: "Las contraseñas no coinciden",
          confirmPasswordRequired: "Confirma tu contraseña",
          nameMin: "Nombre demasiado corto",
          nameMax: "Nombre demasiado largo",
          nameRequired: "El nombre es obligatorio",
          companyNameMin: "Nombre de la empresa demasiado corto",
          companyNameMax: "Nombre de la empresa demasiado largo",
          companyNameRequired: "El nombre de la empresa es obligatorio",
          documentRequired: "CPF o CNPJ es obligatorio",
          emailInvalid: "Correo electrónico inválido",
          emailRequired: "El correo electrónico es obligatorio",
        },
      },
      subscription: {
        form: {
          installments: "Cuotas",
          installmentsHelper: "Divide el total en hasta {{max}} cuotas en tu tarjeta de crédito.",
          installmentsOption: "{{count}}x de R$ {{value}}",
          installmentsOptionSingle: "Pago único — R$ {{value}}",
        },
        warnings: {
          pickInstallments: "Selecciona el número de cuotas.",
        },
        cancel: {
          button: "Cancelar suscripción",
          title: "Cancelar suscripción",
          body: "Mantendrás el acceso al sistema hasta el {{date}}. Después de esa fecha tu cuenta quedará inactiva y no se realizarán más cobros automáticos. Puedes reactivar en cualquier momento eligiendo un nuevo plan.",
          confirm: "¿Estás seguro de que deseas cancelar?",
          back: "Volver",
          confirmButton: "Confirmar cancelación",
          success: "Suscripción cancelada.",
          successWithDate: "Suscripción cancelada. Tendrás acceso hasta el {{date}}.",
        },
        reactivate: {
          button: "Reactivar suscripción",
          title: "Reactivar suscripción",
          body: "Tu suscripción será reactivada. La próxima renovación se cobrará automáticamente el {{date}}.",
          back: "Volver",
          confirmButton: "Confirmar reactivación",
          success: "Suscripción reactivada.",
          successWithDate: "Suscripción reactivada. La próxima renovación será el {{date}}.",
        },
        pixBoletoNote: "Los planes pagados por PIX o Boleto no tienen cobro automático. Para detener, simplemente no pagues la próxima factura.",
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
          forgotPassword: "¿Olvidaste tu contraseña?",
        },
        mfa: {
          newPasswordRequired: "Establece una nueva contraseña para continuar",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar",
          setupTitle: "Configurar autenticación de dos factores",
          setupDescription: "Escanea el código QR con tu aplicación de autenticación (Google Authenticator, Authy, etc.)",
          verificationCode: "Código de verificación",
          verify: "Verificar",
          verifyTitle: "Autenticación de dos factores",
          verifyDescription: "Ingresa el código de tu aplicación de autenticación",
          backToLogin: "Volver al inicio de sesión",
        },
        mfaRecovery: {
          trigger: "¿Perdiste el acceso a tu autenticador?",
          requestTitle: "Recuperación de MFA",
          requestSubtitle: "¿Perdiste el acceso a tu aplicación de autenticación?",
          requestInfo: "Se enviará un código de 6 dígitos a",
          sendCode: "Enviar Código",
          cancel: "Cancelar",
          verifyTitle: "Ingresa el código de recuperación",
          verifySubtitle: "Enviamos un código de 6 dígitos a tu correo.",
          codeLabel: "Código de recuperación",
          verifyButton: "Verificar Código",
          back: "Volver",
          requestNewCode: "Solicitar un nuevo código",
          expiresIn: "El código expira en",
          expired: "Código expirado. Solicita un nuevo código.",
          successTitle: "¡MFA restablecido con éxito!",
          successBody: "La autenticación de dos factores fue restablecida. Ya puedes iniciar sesión de nuevo y configurar un nuevo autenticador.",
          successInfo: "Cierra esta ventana e inicia sesión de nuevo — deberás configurar una nueva aplicación de autenticación.",
          redirecting: "Redirigiendo en {{count}} segundos...",
          closeNow: "Cerrar ahora",
          toasts: {
            codeSent: "¡Código de recuperación enviado a tu correo!",
            resetSuccess: "¡MFA restablecido con éxito!",
          },
        },
        toasts: {
          passwordResetSuccess: "¡Contraseña restablecida con éxito!",
          resetCodeSent: "¡Código de verificación enviado a su correo!",
        },
        forgotPassword: {
          backToLogin: "Volver al inicio de sesión",
          sendCode: "Enviar Código",
          subtitle: "Ingresa tu correo electrónico y te enviaremos un código de verificación.",
          title: "¿Olvidaste tu contraseña?",
        },
        resetPassword: {
          codeLabel: "Código de Verificación",
          newPasswordLabel: "Nueva Contraseña",
          submitButton: "Restablecer Contraseña",
          subtitle: "Ingresa el código enviado a tu correo electrónico y tu nueva contraseña.",
          title: "Restablecer tu contraseña",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
          expired: "Su plan ha expirado. Elija un plan para continuar.",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          groups: "Grupos",
          passiveTickets: "Tickets Pasivos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos",
        buttons: {
          downloadModel: "Descargar Modelo",
          closed: "Cerrar",
          import: "Importar Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers: " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted: "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported: "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage: "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        bulkDelete: {
          noneSelected: "Selecciona al menos una conexión para eliminar.",
          button: "Eliminar Seleccionadas ({{count}})",
          dialogTitle: "¿Eliminar {{count}} conexión(es) seleccionada(s)?",
          dialogMessage: "Esta acción no se podrá revertir.",
          toastSuccess: "{{count}} conexión(es) eliminada(s) con éxito.",
          toastError: "{{count}} conexión(es) no pudieron ser eliminadas.",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content: "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content: "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content: "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Color",
        },
        facebook: {
          success: "¡Página de Facebook conectada con éxito!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
          clientClosed: "El cliente cerró el ticket.",
          redirect: "- redirigido",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc: "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          msgSendQueue: "Mensaje al redirigir a la fila (opcional)",
          importAlert: "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues: "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS: "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS: "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket: "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          triggerIntegrationOnClose: "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
          queuesDisabledByIntegration: "Deshabilitado porque esta conexión ya usa la Integración FlowLive (Entrada). Elimine la integración para poder seleccionar filas.",
          integrationDisabledByQueues: "Deshabilitado porque esta conexión ya tiene filas seleccionadas. Elimine las filas para poder usar la Integración FlowLive (Entrada).",
          business_id: "ID de Negocio",
          flowInactiveTime: "Tiempo en minutos para enviar flujo de inactividad",
          isOficial: "Oficial",
          phone_number: "Número de teléfono",
          send_token: "Token de envío",
          timeAwaitActiveFlow: "Tiempo de espera para flujo activo",
          timeToReturnQueue: "Tiempo para retornar a la cola en minutos",
          waba_id: "WABA ID",
          collectiveVacationSection: "Vacaciones Colectivas",
          collectiveVacationEnd: "Fecha de fin",
          collectiveVacationStart: "Fecha de inicio",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue: "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS: "Es necesario llenar el tiempo para la evaluación para el NPS.",
        errorRatingMessage: "Se debe proporcionar un mensaje de evaluación para NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
        waiting: "Esperando código QR...",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage: "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact: "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport: "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          country: "País",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
        duplicatesToast: {
          summary: "{{imported}} importados, {{duplicates}} duplicados",
          download: "Descargar duplicados",
        },
        importReport: {
          summary: "{{imported}} importados, {{duplicates}} duplicados, {{rejected}} no importados",
          download: "Descargar informe",
          missingFields: "Campos obligatorios ausentes: {{fields}}",
        },
        filters: {
          createdAt: "Creado en",
          to: "Hasta",
        },
        loadMore: "Cargar Más",
        loading: "Cargando...",
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      contactModal: {
        validation: {
          birthDateMin: "Fecha de nacimiento inválida",
          birthDateFuture: "La fecha de nacimiento no puede ser en el futuro",
        },
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
          attendant: "Agente",
          customer_portfolio: "Cartera de Clientes",
          queue: "Cola",
          assignWallet: "Cartera de Clientes",
          whatsapp: "Conexión de Origen:",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage: "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
        wallet: "Cartera",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete: "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración FlowLive (Entrada)",
          integrationTypeId: "Integración FlowLive (Cierre)",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          selectRotationType: "Seleccione el tipo de rotación",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
          randomizeImmediate: "Aleatorizar Automáticamente (Inmediato)",
          typeRandomMode: "Tipo de Rotación",
        },
        toasts: {
          invalidForm: "No se pudo guardar. Revise los campos obligatorios y las opciones del chatbot.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip: "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle: "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent: "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
          flow: "Flujo de FlowLive",
          flowNone: "Ningún flujo vinculado",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning: {
          updateImage: "La imagen se actualizará al guardar",
        },
        password: {
          chars: "8+ caracteres",
          uppercase: "1 mayúscula",
          number: "1 número",
          special: "1 especial",
        },
        validation: {
          birthDateMin: "Fecha de nacimiento inválida",
          birthDateFuture: "La fecha de nacimiento no puede ser en el futuro",
        },
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowConnections: "Permitir acciones en conexiones",
          allowRealTime: "Ver Panel en Tiempo Real",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
          changeEmail: "Cambiar Email",
          changePassword: "Cambiar Contraseña",
          confirmPassword: "Confirmar Contraseña",
          newEmail: "Nuevo Email",
          newPassword: "Nueva Contraseña",
          showCampaign: "Ver Campañas",
          showContacts: "Ver Contactos",
          showFlow: "Ver Flujos",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
          saveEmail: "Guardar Email",
          savePassword: "Guardar Contraseña",
        },
        success: "Usuario guardado satisfactoriamente.",
        errorPasswordMismatch: "Las contraseñas no coinciden.",
        successEmail: "Email actualizado con éxito.",
        successPassword: "Contraseña actualizada con éxito.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
        confirmationModal: {
          deleteMessage: "¿Está seguro de que desea eliminar esta programación?",
          deleteTitle: "Eliminar Programación",
        },
        toasts: {
          deleted: "¡Programación eliminada con éxito!",
        },
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessageLane: "Mensaje de bienvenida del carril",
          mediaFiles: "Medios",
          nextLaneId: "Carril",
          rollbackLaneId: "Volver al carril después de retomar la atención",
          timeLane: "Tiempo en minutos para redirigir al carril",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
          fileOptions: "Lista de archivos",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
          bulkTransfer: "Transferencia Masiva",
          selectAll: "Seleccionar todos",
          deselectAll: "Deseleccionar todos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: {
            title: "Bandeja",
          },
          closed: {
            title: "Resueltos",
          },
          search: {
            title: "Buscar",
          },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          selectAllUsers: "Seleccionar todos",
          clearAllUsers: "Limpiar selección",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
        filters: {
          keyWord: "Palabra clave",
          to: "Hasta",
          updatedAt: "Actualizado en",
        },
        messageHidden: "Mensaje oculto",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer: "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      bulkTransferTicketModal: {
        title: "Transferir {{count}} Ticket(s)",
        button: "Transferir ({{count}})",
        fieldLabelRequired: "Seleccione un atendente (obligatorio)",
        toastSuccessSync: "{{count}} ticket(s) transferido(s) con éxito.",
        toastCompleted: "{{transferred}} de {{total}} ticket(s) transferido(s) con éxito.",
        toastError: "Error al transferir los tickets seleccionados.",
        progressDialogTitle: "Transfiriendo Tickets",
        progressText: "{{current}} de {{total}} tickets transferidos",
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage: "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
          noQueuesWarning: "No estás asignado a ningún sector. Pide a un administrador que te agregue a un sector antes de aceptar esta conversación.",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tenant: "Tenant",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          subscription: "Suscripción",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "CRM",
          allConnections: "Admin conexiones",
          birthdaySettings: "Config. Cumpleaños",
          callHistorical: "Historial de Llamadas",
          files: "Lista de Archivos",
          management: "Gestión",
          reports: "Informes",
          flowbuilder: "FlowLive",
          todoList: "Lista de Tareas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        "pt-BR": "Portugués",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2: "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions: "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions: "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        messageHidden: "Mensaje oculto",
        aiTransfer: {
          title: "Nuevo contacto en la fila {{queue}}",
          titleNoQueue: "Contacto transferido por el Agente FlowLive (sin fila)",
        },
        ticketTransfer: {
          title: "Atención transferida a ti",
        },
        unansweredReminder: {
          title: "Cliente esperando respuesta",
        },
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
          category: "Categoría",
          language: "Idioma",
          metaID: "Meta ID",
          status: "Estado",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
        global: "Global",
        hasMedia: "Con media",
        noQuickMessages: "No hay respuestas rápidas disponibles",
        noResultsFound: "No se encontraron respuestas rápidas para su búsqueda",
        selectMessage: "Seleccionar Respuesta Rápida",
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        duplicatesToast: {
          summary: "{{imported}} importados, {{duplicates}} duplicados",
          download: "Descargar duplicados",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
            pendingTicketStatus: "Pendiente",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
        backButton: "Volver",
        fetchError: "Error al obtener datos del informe",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
        bulkDelete: {
          noneSelected: "Seleccione al menos una fila para eliminar.",
          button: "Eliminar Seleccionadas ({{count}})",
          dialogTitle: "¿Eliminar {{count}} fila(s) seleccionada(s)?",
          dialogMessage: "Esta acción no se puede deshacer. Los tickets de las filas eliminadas seguirán existiendo sin fila asignada.",
          toastSuccess: "{{count}} fila(s) eliminada(s) con éxito.",
          toastError: "{{count}} fila(s) no pudieron ser eliminadas.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      aiKnowledgeFiles: {
        toggleLabel: "Usar base de conocimiento (RAG)",
        hint: "Adjunte PDFs (hasta 5MB cada uno) para que la IA también responda según su contenido.",
        uploadButton: "Subir PDF",
        maxSizeLabel: "Máx. 5MB",
        saveNodeFirst: "Guarde el nodo primero para poder adjuntar archivos.",
        status: {
          processing: "Procesando...",
          ready: "Listo",
          error: "Error",
        },
        errors: {
          mustBePdf: "El archivo debe ser un PDF.",
          tooLarge: "El archivo excede el límite de 5MB.",
          missingApiKey: "Ingrese la API Key antes de adjuntar archivos.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          flow: "Flujo",
          noFlow: "Ningún flujo vinculado",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Integración",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
        toasts: {
          deleted: "¡Integración eliminada con éxito!",
        },
        bulkDelete: {
          noneSelected: "Selecciona al menos una integración para eliminar.",
          button: "Eliminar Seleccionadas ({{count}})",
          dialogTitle: "¿Eliminar {{count}} integración(es) seleccionada(s)?",
          dialogMessage: "Esta acción no se podrá revertir.",
          toastSuccess: "{{count}} integración(es) eliminada(s) con éxito.",
          toastError: "{{count}} integración(es) no pudieron ser eliminadas.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
        bulkDelete: {
          noneSelected: "Seleccione al menos un usuario para eliminar.",
          button: "Eliminar Seleccionados ({{count}})",
          dialogTitle: "¿Eliminar {{count}} usuario(s) seleccionado(s)?",
          dialogMessage: "Esta acción no se puede deshacer. ¿Realmente desea eliminar los usuarios seleccionados?",
          toastSuccess: "{{count}} usuario(s) eliminado(s) con éxito.",
          toastError: "{{count}} usuario(s) no pudieron ser eliminados.",
        },
      },
      companyUsersDrawer: {
        total: "Total: {{- total}} empleados",
        searchPlaceholder: "Buscar por nombre o email",
        empty: "Esta empresa aún no tiene empleados",
        noMatch: "Ningún empleado coincide con la búsqueda",
        noQueue: "Sin sector",
        retry: "Intentar de nuevo",
        errors: {
          fetch: "No se pudieron cargar los empleados",
        },
        profile: {
          admin: "Admin",
          user: "Empleado",
        },
        columns: {
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          queues: "Sectores",
        },
      },
      compaies: {
        title: "Empresas",
        bulkDelete: {
          selected: "{{count}} seleccionada(s)",
          clear: "Limpiar",
          button: "Eliminar seleccionadas",
          dialogTitle: "Eliminar empresas seleccionadas",
          dialogIntro: "Está a punto de eliminar {{count}} empresa(s):",
          dialogWarning: "Todos los datos de estas empresas (empleados, tickets, mensajes, conexiones WhatsApp y suscripciones Asaas) serán eliminados permanentemente. Esta acción no se puede deshacer.",
          confirmWord: "ELIMINAR",
          confirmInputLabel: "Escriba {{word}} para confirmar",
          confirm: "Eliminar",
          cancel: "Cancelar",
          deleting: "Eliminando...",
          failuresTitle: "Fallos durante la eliminación",
          toastAllOk: "{{count}} empresa(s) eliminada(s) con éxito",
          toastPartial: "{{ok}} eliminada(s), {{failed}} fallaron",
          toastError: "No se pudieron eliminar las empresas",
        },
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Último Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Cancelar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          generateInvoice: "Generar Factura",
          employees: "Empleados",
          employeesTooltip: "Ver empleados",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        year: "Año",
        stats: {
          total: "Total",
          sent: "Enviadas",
          errors: "Errores",
          pending: "Pendientes",
        },
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
          id: "ID",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        stage: "Etapa Kanban",
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket: "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues: "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket: "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact: "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets: "Mover automáticamente al cliente a la cartera",
            showNotificationPending: "Mostrar notificación para tickets pendientes",
            copyContactPrefix: "Prefijo para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage: "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle: "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag: "Opps! Debes asignar una tag antes de cerrar el ticket.",
            disableIntegration: "Deshabilitar Integración",
            greetingAcceptedMessage: "Debe configurar un mensaje de bienvenida al aceptar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen: "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed: "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
          scheduledDate: "Fecha de Programación",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
          template: "Plantilla Meta",
        },
        upload: {
          uploading: "Enviando... {{percent}}%",
          finishing: "Enviando a WhatsApp...",
          tooLarge: "{{category}} demasiado grande ({{size}} MB). Máximo permitido por WhatsApp: {{limit}} MB.",
          category: {
            image: "Imagen",
            video: "Video",
            audio: "Audio",
            document: "Documento",
          },
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_NO_FILE_UPLOADED: "Ningún archivo enviado.",
        ERR_AI_KNOWLEDGE_FILE_MUST_BE_PDF: "El archivo debe ser un PDF.",
        ERR_AI_KNOWLEDGE_FILE_TOO_LARGE: "El archivo excede el límite de 5MB.",
        ERR_AI_KNOWLEDGE_MISSING_PARAMS: "Faltan datos para enviar el archivo. Guarde el nodo antes de adjuntar PDFs.",
        ERR_NO_AI_KNOWLEDGE_FILE_FOUND: "Archivo no encontrado.",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND: "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG: "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_DELETE_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "No es posible eliminar mensajes en conexiones API Oficial (Meta) — Meta no permite esta acción.",
        ERR_EDITING_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "No es posible editar mensajes en conexiones API Oficial (Meta) — Meta no permite esta acción.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_INVALID_COUNTRY_CODE: "Código de país inválido.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_FLOW_NOT_FOUND: "Flujo no encontrado.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
        ERR_INVALID_PASSWORD: "La contraseña debe contener mayúsculas, minúsculas, números y caracteres especiales.",
        ERR_INVALID_RESET_CODE: "Código de verificación inválido.",
        ERR_RESET_CODE_EXPIRED: "Código de verificación expirado. Solicite uno nuevo.",
        ERR_LIMIT_EXCEEDED: "Demasiados intentos. Espere unos minutos.",
        ERR_MISSING_EMAIL: "El correo electrónico es obligatorio.",
        ERR_MISSING_RESET_PARAMS: "Complete todos los campos.",
        ERR_CANNOT_REMOVE_GROUP_ADMIN: "No se puede eliminar al administrador del grupo.",
        ERR_CHATBOT_NOT_FOUND_SERVICE: "Servicio de chatbot no encontrado.",
        ERR_CHAT_IS_NOT_GROUP: "Este chat no es un grupo.",
        ERR_CHAT_NOT_FOUND: "Chat no encontrado.",
        ERR_CHECK_NUMBER: "No se pudo verificar el número. Verifique e intente nuevamente.",
        ERR_CODE_EXPIRED: "Código de verificación expirado.",
        ERR_COGNITO_AUTH_FAILED: "Fallo de autenticación. Por favor, intente nuevamente.",
        ERR_COGNITO_UPDATE_EMAIL: "Error al actualizar email. Por favor, intente nuevamente.",
        ERR_EMAIL_ALREADY_IN_USE: "Este email ya está registrado. Por favor, use una dirección de email diferente.",
        ERR_COGNITO_UPDATE_PASSWORD: "Error al actualizar contraseña. Por favor, intente nuevamente.",
        ERR_COGNITO_USER_ALREADY_EXISTS: "Ya existe un usuario con este correo electrónico.",
        ERR_COMPANY_INACTIVE: "Su plan ha expirado. Elija un plan para continuar.",
        ERR_COMPANY_INVALID_NAME: "Ingrese un nombre de empresa válido (mínimo 2 caracteres).",
        ERR_COGNITO_USER_CREATION: "Error al crear cuenta de usuario. Por favor, intente nuevamente.",
        ERR_COGNITO_USER_CREATION_NO_SUB: "Error al crear cuenta de usuario. Contacte al soporte.",
        ERR_CONTACT_NOT_FOUND: "Contacto no encontrado.",
        ERR_DUPLICATED_FINALIZATION_REASON: "Este motivo de finalización ya existe.",
        ERR_EDITING_WAPP_MSG: "Error al editar mensaje de WhatsApp.",
        ERR_EMPTY_MESSAGE: "El mensaje no puede estar vacío.",
        ERR_FINALIZATION_REASON_NOT_FOUND: "Motivo de finalización no encontrado.",
        ERR_FORBIDDEN_ACK_TARGET_COMPANY: "No tiene permiso para esta acción.",
        ERR_GROUP_MUST_HAVE_AT_LEAST_2_USERS: "Un grupo debe tener al menos 2 usuarios.",
        ERR_INVALID_MEDIA_TYPE: "Tipo de medio no válido. Tipos soportados: imagen, audio, video y documento.",
        ERR_INVALID_NUMBER: "Número no válido. Verifique e intente nuevamente.",
        ERR_INVALID_PARAMETER: "Parámetro no válido.",
        ERR_INVALID_TOTP_CODE: "Código de verificación inválido. Verifique e intente nuevamente.",
        ERR_MFA_NOT_CONFIGURED: "La autenticación en dos pasos no está configurada para esta cuenta.",
        ERR_MFA_SETUP_FAILED: "Error al configurar la autenticación en dos pasos. Por favor, intente nuevamente.",
        ERR_MISSING_CHALLENGE_PARAMS: "Faltan parámetros requeridos. Por favor, intente nuevamente.",
        ERR_MISSING_CREDENTIALS: "El correo electrónico y la contraseña son obligatorios.",
        ERR_MISSING_NEW_PASSWORD: "La nueva contraseña es obligatoria.",
        ERR_MISSING_REFRESH_PARAMS: "Faltan parámetros requeridos para renovar la sesión.",
        ERR_MISSING_TOTP_CODE: "El código de verificación es obligatorio.",
        ERR_NO_ANNOUNCEMENT_FOUND: "Anuncio no encontrado.",
        ERR_NO_BAILEYS_DATA_FOUND: "Datos de sesión de WhatsApp no encontrados.",
        ERR_NO_CAMPAIGN_FOUND: "Campaña no encontrada.",
        ERR_NO_CHATBOT_FOUND: "Chatbot no encontrado.",
        ERR_NO_CHAT_FOUND: "Chat no encontrado.",
        ERR_NO_COMPANY_FOUND: "Empresa no encontrada.",
        ERR_NO_CONTACTLIST_FOUND: "Lista de contactos no encontrada.",
        ERR_NO_CONTACTLISTITEM_FOUND: "Elemento de la lista de contactos no encontrado.",
        ERR_NO_DIALOG_CHATBOT_FOUND: "Diálogo de chatbot no encontrado.",
        ERR_NO_DIALOG_FOUND: "Diálogo no encontrado.",
        ERR_NO_FILE_FOUND: "Archivo no encontrado.",
        ERR_NO_HELP_FOUND: "Artículo de ayuda no encontrado.",
        ERR_NO_INTEGRATIONS_FOUND: "Integración no encontrada.",
        ERR_NO_INVOICE_FOUND: "Factura no encontrada.",
        ERR_NO_PARTNER_FOUND: "Socio no encontrado.",
        ERR_NO_PLAN_FOUND: "Plan no encontrado.",
        ERR_NO_PROMPT_FOUND: "Prompt no encontrado.",
        ERR_NO_QUICKMESSAGE_FOUND: "Respuesta rápida no encontrada.",
        ERR_NO_RATING_FOUND: "Evaluación no encontrada.",
        ERR_NO_SCHEDULE_FOUND: "Programación no encontrada.",
        ERR_NO_TAG_FOUND: "Etiqueta no encontrada.",
        ERR_NOT_FOUND_USER_IN_QUEUE: "Usuario no encontrado en la cola.",
        ERR_NO_TICKETNOTE_FOUND: "Nota del ticket no encontrada.",
        ERR_NOT_MESSAGE_TO_IMPORT: "No hay mensajes para importar.",
        ERR_NO_USERS_IN_QUEUE: "No hay usuarios disponibles en esta cola.",
        ERR_PASSWORD_RESET_REQUIRED: "Se requiere restablecimiento de contraseña. Por favor, restablezca su contraseña.",
        ERR_QUEUE_NOT_FOUND: "Cola no encontrada.",
        ERR_REFRESH_FAILED: "Error al renovar la sesión. Por favor, inicie sesión nuevamente.",
        ERR_SENDING_FACEBOOK_MSG: "Error al enviar mensaje de Facebook. Verifique la página de conexiones.",
        ERR_SENDING_WAPP_MSG_GROUP_BLOCKED: "Este grupo ha sido bloqueado. No se pueden enviar mensajes.",
        ERR_TEST_REPLY_DIALOG: "Error al probar el diálogo de respuesta del chatbot.",
        ERR_TEST_SESSION_DIALOG: "Error al probar el diálogo de sesión del chatbot.",
        ERR_UNSUPPORTED_CHALLENGE: "Desafío de autenticación no soportado. Contacte al soporte.",
        ERR_USER_NOT_CONFIRMED: "Cuenta de usuario no confirmada. Verifique su correo electrónico.",
        ERR_USER_NOT_FOUND: "Usuario no encontrado.",
        ERR_USER_QUEUE_NOT_FOUND: "Cola de usuario no encontrada.",
        ERR_PLAN_NOT_FOUND: "Plan no encontrado.",
        ERR_PLAN_IS_TRIAL_USE_TRIAL_FLOW: "Este plan es solo de prueba.",
        ERR_PLAN_INVALID_AMOUNT: "Precio del plan inválido. Contacte soporte.",
        ERR_INVALID_PAYMENT_FLOW: "Método de pago inválido.",
        ERR_PLAN_PAYMENT_METHOD_NOT_ALLOWED: "Este método de pago no está disponible para el plan seleccionado.",
        ERR_PLAN_NAME_RECURRENCE_UNPARSEABLE: "Error de configuración del plan. Contacte soporte.",
        ERR_PLAN_NAME_BILLING_UNPARSEABLE: "Error de configuración del plan. Contacte soporte.",
        ERR_ASAAS_FIRST_PAYMENT_NO_INVOICE_URL: "Error al generar el pago. Intente nuevamente.",
        ERR_ASAAS_BAD_REQUEST: "No pudimos generar el pago. Verifica tus datos e intenta nuevamente.",
        ERR_ASAAS_UNAUTHORIZED: "Error de configuración de la pasarela de pago. Contacte soporte.",
        ERR_ASAAS_HTTP_ERROR: "La pasarela de pago no está disponible. Intenta nuevamente en unos minutos.",
        ERR_ASAAS_NETWORK: "No se pudo conectar con la pasarela de pago. Intenta nuevamente.",
        ERR_ASAAS_API_KEY_MISSING: "Error de configuración de la pasarela de pago. Contacte soporte.",
        ERR_ASAAS_CALLBACK_DOMAIN_NOT_REGISTERED: "El dominio de redirección no está registrado en la pasarela de pago. Contacte soporte.",
        ERR_SIGNUP_ASAAS_FAILED: "Error al crear la cuenta. Intente nuevamente.",
        ERR_INVALID_INSTALLMENT_COUNT: "Número de cuotas inválido para este plan.",
        ERR_INSTALLMENT_LOCK_IN_EFFECT: "Aún tienes cuotas pendientes del plan actual. Espera a que finalicen para cambiar de plan.",
        ERR_ACTIVE_PLAN_SWITCH_BLOCKED: "Ya tienes un plan activo. Espera al final del período actual para cambiar de plan.",
        ERR_NO_RECURRING_RESOURCE_TO_CANCEL: "No hay renovación automática para cancelar en este plan.",
        ERR_COMPANY_ALREADY_INACTIVE: "Tu suscripción ya está inactiva.",
        ERR_SUBSCRIPTION_ALREADY_ACTIVE: "Tu suscripción ya está activa. No es necesario reactivarla.",
        ERR_NO_CREDIT_CARD_TOKEN_TO_REACTIVATE: "No hay una tarjeta guardada para reactivar. Espera al vencimiento y elige un nuevo plan.",
        ERR_REACTIVATE_NOT_SUPPORTED_FOR_SUBSCRIPTION: "La reactivación automática no está disponible para este plan. Espera al vencimiento y elige un nuevo plan.",
        ERR_COMPANY_NOT_FOUND: "Empresa no encontrada.",
        ERR_BILLING_ADMIN_ONLY: "Solo los administradores pueden gestionar la suscripción de la empresa.",
        ERR_INVOICE_NOT_PENDING: "El recordatorio solo se puede enviar para facturas pendientes que aún no vencieron.",
        ERR_INVOICE_ASAAS_LINKED_CANNOT_MANUALLY_EDIT: "Esta factura está vinculada a un cobro real en Asaas — el estado se actualiza automáticamente por Asaas y no puede modificarse manualmente.",
        ERR_INVOICE_INVALID_STATUS_TRANSITION: "Ese cambio de estado no está permitido a partir del estado actual de la factura.",
        ERR_COMPANY_NO_EMAIL: "Esta empresa no tiene un correo electrónico registrado.",
        ERR_MISSING_PAYMENT_FLOW: "Selecciona una forma de pago para continuar.",
        ERR_PLAN_IS_TRIAL: "Este es un plan de prueba y no se puede pagar. Elige un plan pago para continuar.",
        ERR_PLAN_NOT_INSTALLMENT: "Este plan no permite el pago en cuotas.",
        ERR_INVALID_COMPANY_ID: "Identificador de empresa inválido.",
        ERR_INVALID_INSTALLMENT_INPUT: "Número de cuotas inválido.",
        ERR_BULK_DELETE_NO_IDS: "Selecciona al menos una empresa para eliminar.",
        ERR_BULK_DELETE_NO_VALID_IDS: "Ninguna de las empresas seleccionadas puede eliminarse.",
        ERR_BULK_DELETE_PROTECTED_COMPANY: "No se puede eliminar una empresa protegida.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization: "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: "\"number\": \"558599999999\"",
        fieldBody: "\"body\": \"Mensaje\"",
        fieldUserId: "\"userId\": ID de usuario o \"\"",
        fieldQueueId: "\"queueId\": ID de la Cola o \"\"",
        fieldSendSignature: "\"sendSignature\": Firmar mensaje - true/false",
        fieldCloseTicket: "\"closeTicket\": Cerrar el ticket - true/false",
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description: "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: " Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm: "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        groupCreated: "Grupo creado con éxito",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",
        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema",
        },
      },
      contactList: {
        dialog: "Lista de Contactos",
      },
      frontEndErrors: {
        getUsers: "Error al cargar usuarios",
      },
      loading: "Cargando...",
      messageModal: {
        success: {
          save: "¡Mensaje guardado con éxito!",
        },
        title: {
          add: "Agregar Mensaje",
          edit: "Editar Mensaje",
        },
      },
      quickemessages: {
        toasts: {
          deleted: "¡Respuesta rápida eliminada!",
        },
      },
      ticketInfo: {
        invalidPhoneFormat: "Formato de teléfono inválido",
        copyError: "Error al copiar teléfono",
        copyPhone: "Copiar teléfono",
        noPhone: "No hay teléfono disponible para copiar",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        quickMessages: "Respuestas Rápidas",
      },
      ticketList: {
        success: {
          integrationTriggered: "¡Integración activada con éxito!",
        },
      },
      webhookModal: {
        saveSuccess: "¡Webhook guardado con éxito!",
        title: {
          add: "Agregar Webhook",
          edit: "Editar Webhook",
        },
        toasts: {
          update: "¡Webhook actualizado con éxito!",
        },
      },
      triggerFlowModal: {
        cancel: "Cancelar",
        description: "Seleccione un flujo para ejecutar en este ticket. El estado del ticket cambiará a 'chatbot' durante la ejecución.",
        flowId: "ID del flujo",
        noFlows: "No se encontraron flujos activos",
        selectFlow: "Elegir un flujo",
        selectedFlow: "Flujo seleccionado",
        title: "Disparar Flujo",
        trigger: "Disparar Flujo",
        triggering: "Disparando...",
      },
      chatBots: {
        confirmDeleteAll: "¿Está seguro? Todas las opciones internas también serán eliminadas.",
      },
      contactImport: {
        title: "Exportar / Importar Contactos",
      },
      platforms: {
        gclick: {
          tabs: {
            aiAgent: "Agente de I.A.",
            app: "Aplicación",
          },
        },
        table: {
          selected: "{{count}} seleccionada(s)",
          delete: {
            dialogTitle: "¿Eliminar integración?",
            toastSuccess: "Integración eliminada con éxito.",
            message:
              "las credenciales guardadas serán borradas. La habilitación de la empresa sigue activa, así que puede configurarla de nuevo en cualquier momento.",
          },
          bulkDelete: {
            button: "Eliminar Seleccionadas ({{count}})",
            dialogTitle: "¿Eliminar {{count}} integración(es) seleccionada(s)?",
            dialogMessage:
              "Las credenciales guardadas serán borradas. La habilitación de la empresa sigue activa, así que se puede configurar de nuevo en cualquier momento.",
            confirmWord: "ELIMINAR",
            andMore: "y {{count}} más",
            confirmLabel: "Escriba {{word}} para confirmar",
            toastSuccess: "{{count}} integración(es) eliminada(s) con éxito.",
            toastPartial:
              "{{deleted}} eliminada(s), {{failed}} fallaron. Las que fallaron siguen seleccionadas.",
          },
        },
      },
    },
  },
};

export { messages };
